import Storage, { cacheBucket, cacheSuffix, StorageOptions } from "PFCore/base/storage/storage";
import { endsWith, startsWith } from "underscore.string";

export default class MemoryStorage extends Storage {
  private internalStorage: Record<string, string>;

  constructor() {
    super();
    this.internalStorage = {};
  }

  // fallow-ignore-next-line unused-class-member -- called polymorphically via window.storage: Storage
  setItem(key: string, value: any, options: StorageOptions = {}): void {
    this.flushExpired();

    const stringValue = this.stringify(value);
    this.internalStorage[this.storageKey(key)] = stringValue as string;

    if (options.expiresIn) {
      this.internalStorage[this.expirationKey(key)] = this.expirationTimeFor(options.expiresIn);
    } else {
      if (!options.preserveTime) {
        delete this.internalStorage[this.expirationKey(key)];
      }
    }
  }

  // fallow-ignore-next-line unused-class-member -- called polymorphically via window.storage: Storage
  getItem(key: string): any {
    this.flushExpiredItem(key);

    const value = this.internalStorage[this.storageKey(key)];
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  removeItem(key: string): void {
    delete this.internalStorage[this.storageKey(key)];
    delete this.internalStorage[this.expirationKey(key)];
  }

  // fallow-ignore-next-line unused-class-member -- called polymorphically via window.storage: Storage
  clear(): void {
    this.internalStorage = {};
  }

  // fallow-ignore-next-line unused-class-member -- called polymorphically via window.storage: Storage
  key(index: number): string | undefined {
    return Object.keys(this.internalStorage)[index];
  }

  eachKey(callback: (key: string) => void): void {
    Object.keys(this.internalStorage).forEach((key) => {
      if (key && startsWith(key, cacheBucket) && !endsWith(key, cacheSuffix)) {
        callback(key.replace(cacheBucket, ""));
      }
    });
  }

  expirationTime(key: string): number | null {
    const time = this.internalStorage[this.expirationKey(key)];
    if (time) {
      return parseInt(time, 10);
    } else {
      return null;
    }
  }
}
